import { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import _ from 'lodash';
import clsx from 'clsx';
import useStyles from './Dropzone-styles';

interface Props {
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	onUpload: (files: any[]) => void;
	disabled?: boolean;
}

function Dropzone({ disabled, onUpload }: Props) {
	const classes = useStyles();
	const [fileObjects, setFileObjects] = useState([]);

	const onDrop = useCallback(
		(acceptedFiles) => {
			const files = acceptedFiles;
			setFileObjects(files);
		},
		[fileObjects],
	);

	const { acceptedFiles, getInputProps, getRootProps } = useDropzone({
		disabled,
		maxFiles: 1,
		onDrop,
		// Accept: 'video/*'
	});

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	const files = acceptedFiles.map((file: any) => (
		<li key={file.path}>{file.path}</li>
	));

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	const handleSaveFiles = async (files: any[]) => {
		onUpload(files);
	};

	useEffect(() => {
		if (!_.isEmpty(fileObjects)) {
			handleSaveFiles(fileObjects);
		}
	}, [fileObjects]);

	return (
		<div className={clsx(classes.addArea, { [classes.hover]: !disabled })}>
			<div {...getRootProps({ className: 'dropzone' })}>
				<input {...getInputProps()} />

				<p>Arrastra el archivo o da click</p>
			</div>

			<aside>
				{files.length > 0 && (
					<>
						<h4>Archivos</h4>

						<ul>{files}</ul>
					</>
				)}
			</aside>
		</div>
	);
}

export default Dropzone;
